<template>
  <div class="receivingBox">
    <h5>{{info.title}}</h5>
    <p class="message">
      {{info.subTitle}}
    </p>
    <div class="codeInfo">
      {{info.code}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceivingCode',
  props: {
    info: Object
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.receivingBox {
  padding: rem(40) rem(18);
  background-color: #fff;
  border-radius: rem(12);
  color: #000;
  h5 {
    padding-bottom: rem(14);
    line-height: rem(42);
    font-size: rem(36);
    font-family: 'Aspira Medium';
    font-weight: 500;
  }
  .message {
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: rem(28);
    line-height: rem(34);
    word-break: break-all;
    word-wrap: break-word;
  }
  .codeInfo {
    padding-top: rem(20);
    font-size: rem(60);
    line-height: rem(70);
    font-weight: 500;
    font-family: 'Aspira Medium';
  }
}
</style>
